import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import FormX from 'sb-formx'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants } from 'common/helpers'
import { required } from 'helpers/validation'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import { Field } from 'components/_new/forms'
import Button from 'components/buttons/Button/Button'
import AgeSelect from 'compositions/form/AgeSelect/AgeSelect'
import SkinTypeSelect from 'compositions/form/SkinTypeSelect/SkinTypeSelect'

import ShareToggler from '../ShareToggler/ShareToggler'
import SelectRating from '../SelectRating/SelectRating'

import messages from './messages'
import s from './ReviewComposerModal.scss'


const form = new FormX({
  name: 'ReviewForm',
  fields: {
    title: [ required ],
    text: [ required ],
    rating: [ required ],
    ageCategory: [],
    skinType: [],
  },
})

class ReviewComposerModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.object,
    product: PropTypes.shape({
      id: PropTypes.number,
      img: PropTypes.string, // @deprecated
      image: PropTypes.string,
      name: PropTypes.string,
      brand: PropTypes.string,
      category: PropTypes.string,
      typeGroup: PropTypes.string,
    }).isRequired,
    shouldBeShared: PropTypes.shape({
      facebook: PropTypes.bool,
      twitter: PropTypes.bool,
    }).isRequired,
    data: PropTypes.shape({
      reviewId: PropTypes.number,
      withItemList: PropTypes.bool,
      initialRating: PropTypes.number,
      onReviewAdded: PropTypes.func,
    }),
  }

  static defaultProps = {
    name: constants.modals.review.ReviewComposer,
    data: {
      withItemList: false,
    },
  }

  constructor({ skinType, ageCategory, data: { initialRating } }) {
    super()

    form.setInitialValues({ skinType, ageCategory, rating: initialRating })

    this.state = {
      isFetching: false,
    }
  }

  componentDidMount() {
    actions.models.facebook.init()
  }

  componentWillUnmount() {
    form.unsetValues()
  }

  setFetching = (status) => {
    this.setState({ isFetching: status })
  }

  submit = (values) => {
    const {
      name, product: { id: productId, typeGroup },
      data: { withItemList, onReviewAdded },
    } = this.props
    const { ageCategory, skinType } = values

    this.setFetching(true)

    actions.models.review.add({
      ...values,
      productId,
    })
      .then(
        ({ id }) => {
          if (typeof onReviewAdded === 'function') {
            onReviewAdded(productId, values)
          }

          if (typeGroup === constants.productTypeGroups.perfume) {
            actions.models.modals.open(constants.modals.review.ReviewTags, {
              productId,
              withItemList,
              reviewId: id,
              // We need reload reviews to update the review we created with tags from ReviewsTags result
              onReviewTagsVoted: () => {
                if (typeof onReviewAdded === 'function') {
                  onReviewAdded(productId, values)
                }
              },
            })
          }
          else if (typeGroup === constants.productTypeGroups.skincare) {
            actions.models.modals.open(constants.modals.review.Recommendations, {
              isSkincareGroup: true,
            })
          }

          if (ageCategory || skinType) {
            actions.models.me.setAgeAndSkinType({ ageCategory, skinType })
          }

          actions.models.modals.close(name)
        },
        () => {
          this.setFetching(false)
        }
      )
  }

  handleSubmit = () => {
    form.submit()
      .then(this.submit)
  }

  render() {
    const { isFetching } = this.state
    const {
      name: modalName,
      product: { img, image, brand, name, category, typeGroup },
    } = this.props

    const imgSrc = image || img

    const commentPlaceholder = (
      typeGroup === constants.productTypeGroups.makeup
        ? messages.makeupReviewPlaceholder
        : messages.reviewPlaceholder
    )

    const isSkincare = typeGroup === constants.productTypeGroups.skincare

    return (
      <Modal className={s.modal} name={modalName}>
        <FormattedHTMLMessage className={s.mainTitle} tag="div" {...messages.mainTitle} />
        <img className={s.previewImage} src={imgSrc} alt={`${category} preview`} />
        <div className={s.brand}>{brand}</div>
        <div className={s.name}>{name}</div>
        <div className={s.category}>{category}</div>
        <div className={s.rowItem}>
          <SelectRating field={form.fields.rating} />
          <Field
            className={s.rowItem}
            placeholder={messages.titleLabel}
            field={form.fields.title}
            standardView
          />
          <Field
            className={s.rowItem}
            label={messages.reviewLabel}
            field={form.fields.text}
            placeholder={commentPlaceholder}
            standardView
            rows={9}
          />
          {
            isSkincare ? (
              <Fragment>
                <FormattedHTMLMessage className={cx(s.hint, s.rowItem)} tag="div" {...messages.hint} />
                <div className={cx(s.rowItem, s.additionalBox)}>
                  <div className={s.ageAndSkinTypeButtons}>
                    <div className={s.ageAndSkinTypeButton}>
                      <AgeSelect field={form.fields.ageCategory} />
                    </div>
                    <div className={s.ageAndSkinTypeButton}>
                      <SkinTypeSelect field={form.fields.skinType} />
                    </div>
                  </div>
                  <ShareToggler className={s.shareToggler} />
                </div>
              </Fragment>
            ) : (
              <ShareToggler className={cx(s.rowItem, s.shareToggler)} />
            )
          }
          <div className={s.buttons}>
            <Button
              title={messages.submitButtonTitle}
              loading={isFetching}
              brand
              xlg
              doublePadding
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </Modal>
    )
  }
}


export default connect({
  product: (state, props) => {
    if (props.data && typeof props.data.product !== 'undefined') {
      return props.data.product
    }

    return state.models.review.product
  },
  shouldBeShared: (state, props) => {
    if (props.data && typeof props.data.shouldBeShared !== 'undefined') {
      return props.data.shouldBeShared
    }

    return state.models.review.shouldBeShared
  },
  skinType: 'models.me.skinType',
  ageCategory: 'models.me.ageCategory',
})(ReviewComposerModal)
